import { Component, OnInit, Output, EventEmitter, TemplateRef, Input } from '@angular/core';
import { OfferInputModel } from '../../shared/models/OfferInputModel';
import { PropertyDetailForOffer } from '../../shared/models/PropertyDetailForOffer';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../../shared/auth/authentication.service';

interface IMatchingUsers {
  UserId: number;
  FirstName: string;
  LastName: string;
  Email: string;
  Phone: string;
  Company: string;
  ProfilePic: string;
}

@Component({
  selector: 'app-offer-edit',
  templateUrl: './offer-edit.component.html',
  styleUrls: ['./offer-edit.component.css']
})
export class OfferEditComponent implements OnInit {
  modalRef: BsModalRef;
  modalRefMatching: BsModalRef;
  @Output() close = new EventEmitter();
  @Input() propType: number = 601;
  @Input() leadGUID: string;
  @Input() LivePropertyGuid: string='';
  propertyGuid: string = "";
  propertyGuidSlug: string;
  fromOfferMatrix: boolean = true;

  constructor(private modalService: BsModalService,
    private activatedRoute: ActivatedRoute, public authService: AuthenticationService,
    private router: Router, ) {
  }

  ngOnInit(): void {
  }

  closeModal() {
    this.close.emit();
  }
}
